
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Mumbaitopunecab() {



    const cardData =
    {
        keyword: 'Mumbai to Pune Cab',
        heading: 'Meghana Cab : Mumbai to Pune Cab',
        headingDescription: 'Meghana Cab offers Mumbai to Pune Cab services, delivering a convenient, comfortable, and on-time travel experience for commuters between the two bustling cities. Whether you are returning home, heading for a business meeting, or planning a weekend trip, our clean and well-maintained cabs with experienced drivers ensure a safe and smooth ride. Enjoy transparent pricing, multiple vehicle choices, and 24/7 customer support. Book your Mumbai to Pune Cab with Meghana Cab and travel worry-free with trusted service and comfort.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "A historical fortification built in 1732, Shaniwar Wada was once the seat of the Peshwas of the Maratha Empire. The grand gateway, expansive ruins, and the evening light and sound show depicting Maratha history make it one of Pune’s most important landmarks for cultural and heritage tourism."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, the Aga Khan Palace holds deep significance in India’s freedom struggle. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi. The palace is surrounded by lush gardens and houses a museum with Gandhian artifacts and personal belongings."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 30 km from Pune, this fort is a popular destination for trekking and history lovers. It was the site of the Battle of Sinhagad in 1670, and offers panoramic views of the surrounding valleys. Visitors also enjoy local food like pithla bhakri at the summit."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum showcases over 20,000 artifacts including musical instruments, traditional utensils, sculptures, and textiles. It offers a glimpse into India’s rich artistic and cultural history, particularly from Maharashtra."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century rock-cut temple located in the heart of the city, Pataleshwar is dedicated to Lord Shiva. It features a circular Nandi mandapa and intricately carved pillars. The temple is a peaceful heritage site amidst urban surroundings."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Situated in Koregaon Park, this globally renowned spiritual retreat attracts visitors interested in meditation, wellness, and holistic healing. The campus offers a tranquil setting with daily meditation sessions and therapy workshops."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend getaway for Pune residents, this dam provides water to the city and is surrounded by scenic views of hills and greenery. It's ideal for picnics, photography, and relaxing by the water during early mornings or evenings."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by a Japanese garden in Okayama, this beautifully landscaped public park features manicured lawns, flowing streams, and charming bridges. It's a favorite spot for family outings and peaceful strolls."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shivaji Maharaj’s father, Shahaji, this reconstructed palace commemorates the early life of Chhatrapati Shivaji Maharaj. It houses paintings, artifacts, and replicas reflecting Maratha heritage."
  },
  {
    "title": "Fergusson College Road",
    "description": "Known for its lively ambiance and youthful vibe, this road is a hub for students, with a wide variety of cafes, bookstores, fashion outlets, and street food. It reflects the cultural vibrancy and modern spirit of Pune."
  }
],

"services": [
    {
        "name": "Cab Booking Mumbai to Pune",
        "description": "Book a reliable and comfortable cab from Mumbai to Pune with Meghana Cab. Our service offers a hassle-free experience with prompt pickups, professional drivers, and a range of vehicle options to suit your travel needs. Whether it's a business trip or leisure travel, enjoy safe and timely rides every time."
    },
    {
        "name": "One Way Taxi Mumbai to Pune",
        "description": "Plan your journey efficiently with Meghana Cab's one-way taxi service from Mumbai to Pune. Perfect for quick trips, airport transfers, or day visits, our well-maintained vehicles ensure a smooth and comfortable ride tailored to your schedule and preferences."
    },
    {
        "name": "Mumbai Airport to Pune Cab",
        "description": "Get seamless airport transfer service from Mumbai Airport to Pune with Meghana Cab. Avoid long waits and stressful commutes by booking your AC cab in advance. Our courteous drivers assist with your luggage and ensure timely arrivals for flights or comfortable rides post-landing."
    },
    {
        "name": "Mumbai to Pune Round Trip Taxi",
        "description": "Opt for a convenient round trip taxi from Mumbai to Pune for your meetings, events, or weekend getaways. Meghana Cab offers flexible packages with professional chauffeurs, clean vehicles, and hassle-free booking for both business and leisure travelers."
    },
    {
        "name": "SUV Hire Mumbai to Pune Trip",
        "description": "Travel comfortably with family or in a group by hiring an SUV taxi from Mumbai to Pune. Our spacious SUVs offer ample luggage space and premium amenities, ensuring a relaxing and enjoyable journey, no matter the distance."
    },
    {
        "name": "AC Cab Mumbai to Pune",
        "description": "Beat the heat with Meghana Cab’s air-conditioned taxi service from Mumbai to Pune. Our fleet includes well-maintained sedans and SUVs equipped with AC, providing a cool and comfortable environment throughout your trip."
    },
    {
        "name": "Fastest Taxi Mumbai to Pune",
        "description": "Need to reach Pune quickly? Meghana Cab offers the fastest taxi services from Mumbai with professional drivers who know the best routes and traffic patterns, ensuring you arrive on time without compromising safety."
    },
    {
        "name": "Safe Taxi Ride from Mumbai to Pune",
        "description": "Safety is our priority at Meghana Cab. Our Mumbai to Pune rides come with well-trained drivers, regular vehicle maintenance, and strict hygiene protocols, ensuring you travel securely and comfortably."
    },
    {
        "name": "Online Booking Cab Mumbai to Pune",
        "description": "Book your Mumbai to Pune cab easily and instantly online with Meghana Cab. Our simple booking process, secure payment options, and real-time confirmation make arranging your ride quick and convenient."
    },
    {
        "name": "Mumbai to Pune Sedan Taxi",
        "description": "Choose our sedan taxis for a smooth and stylish ride from Mumbai to Pune. Ideal for business travelers and small families, our sedans combine comfort, affordability, and punctuality for all your travel needs."
    },
    {
        "name": "Budget Cab Hire Mumbai to Pune",
        "description": "Travel smart with Meghana Cab’s budget-friendly taxi services from Mumbai to Pune. We offer affordable rates without compromising on quality, making your journey cost-effective and comfortable."
    },
    {
        "name": "24/7 Taxi from Mumbai to Pune",
        "description": "No matter the time, Meghana Cab provides 24/7 taxi services from Mumbai to Pune. Whether you have an early morning flight or a late-night meeting, we ensure availability and prompt service whenever you need it."
    },
    {
        "name": "Premium Mumbai to Pune Car Rental",
        "description": "Experience luxury travel with Meghana Cab’s premium car rentals from Mumbai to Pune. Our high-end vehicles are perfect for executives, special occasions, or those seeking added comfort and style on their journey."
    },
    {
        "name": "Mumbai to Pune Road Trip Taxi",
        "description": "Enjoy the scenic route and make stops along the way with Meghana Cab’s road trip taxi service from Mumbai to Pune. Perfect for leisure travelers who want flexibility and a personalized travel experience."
    },
    {
        "name": "Chauffeur Driven Cab Mumbai to Pune",
        "description": "Relax and enjoy your journey with our chauffeur-driven cabs from Mumbai to Pune. Our professional drivers ensure a smooth, safe, and comfortable ride, handling all the driving so you can focus on your work or relax."
    }
],

"tableData": [
    ["Cab Booking Mumbai to Pune", "One Way Taxi Mumbai to Pune"],
    ["Mumbai Airport to Pune Cab", "Mumbai to Pune Round Trip Taxi"],
    ["SUV Hire Mumbai to Pune Trip", "AC Cab Mumbai to Pune"],
    ["Fastest Taxi Mumbai to Pune", "Safe Taxi Ride from Mumbai to Pune"],
    ["Online Booking Cab Mumbai to Pune", "Mumbai to Pune Sedan Taxi"],
    ["Budget Cab Hire Mumbai to Pune", "24/7 Taxi from Mumbai to Pune"],
    ["Premium Mumbai to Pune Car Rental", "Mumbai to Pune Road Trip Taxi"],
    ["Chauffeur Driven Cab Mumbai to Pune", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Mumbai to Pune Cab Service",
        "WhyChoosedescription": "Meghana Cab offers dependable and comfortable Mumbai to Pune cab services designed to make your journey smooth and hassle-free. Whether traveling for work or leisure, you can count on us for timely pickups and drop-offs."
    },
    {
        "WhyChooseheading": "Experienced Drivers Well-Versed with Routes",
        "WhyChoosedescription": "Our professional drivers are familiar with the Mumbai-Pune Expressway and alternate routes, ensuring a safe and efficient trip while navigating traffic conditions and roadworks."
    },
    {
        "WhyChooseheading": "Variety of Vehicle Choices to Suit Your Travel Needs",
        "WhyChoosedescription": "From economical sedans to spacious SUVs, Meghana Cab provides a wide range of well-maintained and sanitized vehicles for solo travelers, families, and groups."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "We offer clear and affordable pricing with no hidden costs, making it easier for you to plan your budget and travel with confidence on your Mumbai to Pune cab ride."
    },
    {
        "WhyChooseheading": "Comfortable and Clean Cabs for a Pleasant Journey",
        "WhyChoosedescription": "All our cabs are equipped with air conditioning, comfortable seating, and regular sanitization to ensure a safe and enjoyable travel experience from Mumbai to Pune."
    },
    {
        "WhyChooseheading": "24/7 Availability to Match Your Schedule",
        "WhyChoosedescription": "Our cab services operate round-the-clock, enabling you to book rides anytime, whether early morning flights, late-night arrivals, or urgent business trips."
    },
    {
        "WhyChooseheading": "Easy Booking via Website, App, or Phone",
        "WhyChoosedescription": "Reserve your Mumbai to Pune cab effortlessly through Meghana Cab’s user-friendly online platforms or customer support, with instant booking confirmation and real-time vehicle tracking."
    },
    {
        "WhyChooseheading": "Priority on Safety and Customer Satisfaction",
        "WhyChoosedescription": "We ensure all drivers adhere to strict safety standards and follow traffic rules, with GPS-enabled vehicles for your peace of mind and round-the-clock customer assistance."
    }
]




































    }

const faqData = [
    {
        question: "How can I book a cab from Mumbai to Pune with Meghana Cab?",
        answer: "You can book a Mumbai to Pune cab by calling Meghana Cab at +91 9075462128 or via our website for easy booking."
    },
    {
        question: "What types of vehicles are available for Mumbai to Pune trips?",
        answer: "We offer sedans, SUVs, and tempo travellers suitable for comfortable travel from Mumbai to Pune."
    },
    {
        question: "Are the drivers experienced with Mumbai to Pune routes?",
        answer: "Yes, our drivers are well-versed with the Mumbai to Pune route ensuring a safe and timely journey."
    },
    {
        question: "Can I book a one-way or round-trip cab from Mumbai to Pune?",
        answer: "Yes, Meghana Cab provides both one-way and round-trip options based on your travel needs."
    },
    {
        question: "What is included in the Mumbai to Pune cab fare?",
        answer: "The fare includes driver charges, fuel, and vehicle maintenance. Additional charges like tolls and parking may apply."
    },
    {
        question: "Is Meghana Cab available 24/7 for Mumbai to Pune bookings?",
        answer: "Yes, our services operate round-the-clock to assist with Mumbai to Pune cab bookings."
    },
    {
        question: "Can I book a cab for a group traveling from Mumbai to Pune?",
        answer: "Yes, we offer tempo travellers and SUVs for larger groups."
    },
    {
        question: "Are the vehicles clean and sanitized for travel?",
        answer: "All vehicles are regularly cleaned and sanitized to ensure passenger safety."
    },
    {
        question: "What payment methods are accepted for Mumbai to Pune cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
    {
        question: "How can I contact Meghana Cab for Mumbai to Pune cab services?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Mumbai to Pune cab services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Ramesh Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab provided a comfortable and punctual Mumbai to Pune cab service. The driver was professional.”',
    },
    {
        name: 'Ms. Neha Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly recommend Meghana Cab for Mumbai to Pune travel. The vehicle was clean and the ride smooth.”',
    },
];






























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Cab",
  "image": "https://www.meghanacabs.com/assets/images/mumbai-to-pune-cab.jpg",
  "description": "Book Mumbai to Pune cab with Meghana Cabs for a safe, fast, and affordable ride. Choose from AC sedans, SUVs, chauffeur-driven cars, one-way or round trip options—available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5610"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1700",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/mumbai-to-pune-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Mumbai to Pune Cab | Safe, Affordable & 24/7 Taxi Booking | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune cab with Meghana Cabs for a safe, fast, and affordable ride. Choose from AC sedans, SUVs, chauffeur-driven cars, one-way or round trip options—available 24/7." 
  />
  <meta 
    name="keywords" 
    content="Cab Booking Mumbai to Pune, One Way Taxi Mumbai to Pune, Mumbai Airport to Pune Cab, Mumbai to Pune Round Trip Taxi, SUV Hire Mumbai to Pune Trip, AC Cab Mumbai to Pune, Fastest Taxi Mumbai to Pune, Safe Taxi Ride from Mumbai to Pune, Online Booking Cab Mumbai to Pune, Mumbai to Pune Sedan Taxi, Budget Cab Hire Mumbai to Pune, 24/7 Taxi from Mumbai to Pune, Premium Mumbai to Pune Car Rental, Mumbai to Pune Road Trip Taxi, Chauffeur Driven Cab Mumbai to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/27.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopunecab;